import { Injectable } from '@angular/core';
import { Highcharts$ } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {
  constructor() {}

  uniqueArray(a) {
    const seen = {};
    const out = [];
    const len = a.length;
    let j = 0;
    for (let i = 0; i < len; i++) {
      const item = a[i];
      if (seen[item] !== 1) {
        seen[item] = 1;
        out[j++] = item;
      }
    }
    return out;
  }

  displayPlantLogo(url: string) {
    let dom: any;
    let elem = document.getElementById('imgPlantLogo');
    if (elem === null) {
      elem = document.createElement('img');
      elem.setAttribute('id', 'imgPlantLogo');
    }
    elem.setAttribute('src', './assets/img/Fuso_Logo.png');
    elem.setAttribute('height', '120');
    elem.setAttribute('width', '296');
    elem.setAttribute('alt', 'Flower');

    dom = document.getElementsByClassName('sidenav-header');
    dom[0].appendChild(elem);
  }
  displayPlantLayout(siteId: string) {
    let elem = document.getElementById('imgPlantLayout');
    elem.style.backgroundImage =
      'url(./assets/img/dashboard/layout/' + siteId + '.png)';
    elem.style.backgroundPosition = 'center';
  }
  displayPlantSolarLayout(url: string) {
    let elem = document.getElementById('imgPlantSolarLayout');
    elem.style.backgroundImage = 'url(' + url + ')';
    elem.setAttribute('height', '550');
    elem.setAttribute('alt', 'PlantLayout');
    elem.setAttribute('crossorigin', 'anonymous');
  }
  removePlantLogo() {
    let dom: any;
    let elem = document.getElementById('imgPlantLogo');
    if (elem !== null) {
      dom = document.getElementsByClassName('sidenav-header');
      dom[0].removeChild(elem);
    }
  }
  public enableDraggingHighChart = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    (function (H: any) {
      const addEvent = H.addEvent;
      H.wrap(
        H.Chart.prototype,
        'init',
        function (proceed: { apply: (arg0: any, arg1: any) => void }) {
          proceed.apply(this, Array.prototype.slice.call(arguments, 1));
          // eslint-disable-next-line prefer-const
          let chart = this,
            // eslint-disable-next-line prefer-const
            legend = chart.legend,
            // eslint-disable-next-line prefer-const
            box = legend.box,
            // eslint-disable-next-line prefer-const
            options = legend.options,
            isDragging: boolean,
            downX: number,
            downY: number,
            optionsX: number,
            optionsY: number,
            currentX: number,
            currentY: number;
          if (options.draggable) {
            box.css({ cursor: 'move' });
            addEvent(
              box.element,
              'mousedown',
              function (e: { chartX: number; chartY: number }) {
                e = chart.pointer.normalize(e);
                downX = e.chartX;
                downY = e.chartY;
                optionsX = options.x;
                optionsY = options.y;
                currentX = legend.group.attr('translateX');
                currentY = legend.group.attr('translateY');
                isDragging = true;
              }
            );
            addEvent(
              chart.container,
              'mousemove',
              function (e: { chartX: number; chartY: number }) {
                if (isDragging) {
                  e = chart.pointer.normalize(e);
                  const draggedX = e.chartX - downX,
                    draggedY = e.chartY - downY;
                  options.x = optionsX + draggedX;
                  options.y = optionsY + draggedY;
                  // Do the move is we're inside the chart
                  if (
                    currentX + draggedX > 0 &&
                    currentX + draggedX + legend.legendWidth <
                      chart.chartWidth &&
                    currentY + draggedY > 0 &&
                    currentY + draggedY + legend.legendHeight <
                      chart.chartHeight
                  ) {
                    legend.group.placed = false; // prevent animation
                    legend.group.align(
                      H.extend(
                        {
                          width: legend.legendWidth,
                          height: legend.legendHeight
                        },
                        options
                      ),
                      true,
                      'spacingBox'
                    );
                  }
                  if (chart.pointer.selectionMarker) {
                    chart.pointer.selectionMarker =
                      chart.pointer.selectionMarker.destroy();
                  }
                }
              }
            );
            addEvent(document, 'mouseup', function () {
              isDragging = false;
            });
          }
        }
      );
    })(Highcharts$);
  };
  public alwaysVisibleTooltipSolidGauge = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    (function (H: any) {
      H.wrap(
        H.Tooltip.prototype,
        'hide',
        function (p: { call: (arg0: any, arg1: any) => void }, delay: any) {
          if (this.options.alwaysVisible) {
            return this.refresh(this.chart.series[0].data[0]);
          }
          p.call(this, delay);
        }
      );
    })(Highcharts$);
  };
}
